import errorMessages from 'constants/errorMessages';

export const PROFILE_MAX_UPLOAD_SIZE = 10 * 1024; // 10kb
export const PROFILE_IMAGE_ACCEPT = '.jpg, .jpeg, .JPEG';
export const serverErrorMessage = errorMessages.defaultServerError;
export const UNSUPPORT_FILE_TYPE_ERROR_MESSAGE = 'Неверный тип файла.';
export const FILE_SIZE_ERROR_MESSAGE = 'Превышен максимальный размер файла.';

export const PERSONAL_TABLE_DATA_TITLE = {
  inn: 'ИНН',
  dateOfBirth: 'Дата рождения',
  placeOfBirth: 'Место рождения',
  name: 'Вид документа, удостоверяющего личность',
  dulNumber: 'Серия и номер документа, удостоверяющего личность',
  dulDate: 'Дата выдачи документа, удостоверяющего личность',
  dulIssuedBy: 'Кем выдан документ, удостоверяющий личность',
  dulUnit: 'Код подразделения',
  snils: 'СНИЛС',
  residenceAddress: 'Адрес места жительства (места пребывания при отсутствии места жительства)',
  fullName: 'ФИО',
  email: 'E-mail',
  residenceRegistrationDate: 'Дата регистрации по месту жительства',
};
export const PERSONAL_DATA_FIELD_KEYS = [
  'inn',
  'dateOfBirth',
  'placeOfBirth',
  'name',
  'dulNumber',
  'dulDate',
  'dulIssuedBy',
  'dulUnit',
  'snils',
  'residenceAddress',
];
